import React from 'react';
import { CircularProgress } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import { useStyles } from './styles';

interface ILoadingProps {
  isLoading?: boolean;
}

const Loading: React.FC<ILoadingProps> = ({
  isLoading = true,
}: ILoadingProps) => {
  const classes = useStyles();
  return (
    <Backdrop open={isLoading} className={classes.backdrop}>
      <CircularProgress size={40} />
    </Backdrop>
  );
};

export default Loading;
